import React from 'react';
import './Section5.css'


const Section5 = () => {

  return (
<section className="comments">
      <div
        className="background bg-img bg-fixed section-padding pb-0 d-flex align-items-center"
        style={{
          backgroundImage: 'url("/ecoCabaña2.jpg")',
          height: '500px', // Set to the height of your image (in pixels or percentage)
          backgroundSize: 'cover', // Ensure it covers the section
          backgroundPosition: 'center center', // Center the image
        }}
      >
        <div className="container text-start">
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <div className="testimonials-box">
                <div className="head-box">
                <h5 className="section-subtitle text-uppercase text-white">Opiniones</h5>
                  <h4 className="text-white">Comentarios de nuestros visitantes.</h4>
                  <div className="line mx-auto"></div>
                </div>
                {/* Bootstrap Carousel */}
                <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-inner">
                    {/* Testimonial 1 */}
                    <div className="carousel-item active">
                      <p className="text-white">Vine sin expectativas y me voy con ganas de volver</p>
                      <div className="info d-flex align-items-center">
                        <div className="author-img">
                          <img
                            src="/ecoCabaña2.jpg"
                            alt="Maria Juliana Restrepo"
                            className="rounded-circle"
                            width="50"
                            height="40"
                          />
                        </div>
                        <div className="cont ms-3">
                          <span className="d-block">
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                          </span>
                          <h6 className="text-white">Silvia Sierra Sierra</h6>
                        </div>
                      </div>
                    </div>
                    {/* Testimonial 2 */}
                    <div className="carousel-item">
                      <p className="text-white">Un destino que no solo visitas, sino que vives</p>
                      <div className="info d-flex align-items-center">
                        <div className="author-img">
                          <img
                            src="/ecoCabaña2.jpg"
                            alt="Sara Corrales"
                            className="rounded-circle"
                            width="50"
                            height="40"
                          />
                        </div>
                        <div className="cont ms-3">
                          <span className="d-block">
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                          </span>
                          <h6 className="text-white">Fabian Martinez Martelo</h6>
                        </div>
                      </div>
                    </div>
                    {/* Testimonial 3 */}
                    <div className="carousel-item">
                      <p className="text-white">Qué gusto da viajar y toparse con joyitas como esta</p>
                      <div className="info d-flex align-items-center">
                        <div className="author-img">
                          <img
                            src="/ecoCabaña2.jpg"
                            alt="Karin Kipke"
                            className="rounded-circle"
                            width="50"
                            height="40"
                          />
                        </div>
                        <div className="cont ms-3">
                          <span className="d-block">
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                          </span>
                          <h6 className="text-white">Jhonatan Martinez</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Carousel Dots */}
                  <div className="carousel-indicators">
                    <button
                      type="button"
                      data-bs-target="#testimonialCarousel"
                      data-bs-slide-to="0"
                      className="active"
                      aria-current="true"
                      aria-label="Slide 1"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#testimonialCarousel"
                      data-bs-slide-to="1"
                      aria-label="Slide 2"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#testimonialCarousel"
                      data-bs-slide-to="2"
                      aria-label="Slide 3"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Section5
